/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";

import { Dialog, Box, Grid, Typography, Link, Button, IconButton, Backdrop } from "@mui/material";
import OtpInput from "react-otp-input";
import { styled } from "@mui/system";
import Cloud from "./svg/otp-cloud.svg";
import CloudSuccess from "./svg/otp-cloud-success.svg";
import CloseIcon from "./svg/close-icon.svg";
import $axios from "../../../../utils/axios";
import { setCustomer } from "../../../../store/account/account.slice";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { isCn } from "../../../../utils/general";
import RegisterService from "@services/register-service";
// import Tap from "@tapfiliate/tapfiliate-js";

interface Props {
  open: boolean;
  setOpen: (state: boolean) => void;
  handleNext: () => void;
  email: string;
  onSubmit: (otp: string, setError: React.Dispatch<React.SetStateAction<boolean>>) => Promise<void>;
  onResend:()=>Promise<void>
}

const ConfirmOtp: React.FC<Props> = ({ open, setOpen, onSubmit, email,onResend }: Props) => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [clicked, setClicked] = useState(false);
  const { search } = useLocation();

  const handleClose = () => {
    setOtp("");
    setOpen(false);
  };
  const { executeRecaptcha } = useGoogleReCaptcha();
  const handleReCaptchaVerify = useCallback(async (): Promise<string | undefined> => {
    if (!executeRecaptcha) {
      console.log("Execute recaptcha not yet available");
      return;
    }
    try {
      const token = await executeRecaptcha("login");
      return token;
    } catch (e) {
      console.error(e);
      location.reload();
    }
  }, [executeRecaptcha]);

  const handleSubmit = async () => {
    setClicked(true);
    try {
      await onSubmit(otp, setError);
      setClicked(false);
    } catch (e: any) {
      setError(true);
      setClicked(false);
    }
  };


  const handleOtpChange = (value: string) => {
    setOtp(value);
  };

  useEffect(() => {
    if (otp.length === 6) {
      setError(false);
      setSuccess(true);
    } else {
      setError(false);
      setSuccess(false);
    }
  }, [otp]);
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        transitionDuration={{ exit: 0 }}
        BackdropComponent={styled(Backdrop, {
          name: "MuiModal",
          slot: "Backdrop",
          overridesResolver: (props, styles) => {
            return styles.backdrop;
          },
        })({
          backgroundColor: "rgba(117, 90, 190, 0.55)",
          backdropFilter: "blur(4px)",
          borderRadius: "10.3px",
        })}
        fullWidth={true}
        disableAutoFocus
      >
        <Grid
          container
          item
          sx={{
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
          }}
        >
          <Grid
            container
            item
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={4}
            sx={{
              position: "relative",
            }}
          >
            <IconButton onClick={handleClose} sx={{ p: 0, position: "absolute", right: 5, top: 5 }} aria-label="close Dialog">
              <img loading="lazy" src={CloseIcon} alt="close Dialog icon" />
            </IconButton>
            <Box mb={4}>
              <img loading="lazy" src={success ? CloudSuccess : Cloud} alt="cloud image" />
            </Box>
            <Typography mb={1} variant="h3" color="text.secondary" fontWeight="bold">
              {t("OTP Verification")}
            </Typography>
            <Typography mb={3} variant="subtitle1" color="text.primary">
              {t("Enter OTP Code sent to")}{" "}
              <Typography component="span" fontWeight="bold" color="text.primary">
                {email}
              </Typography>
            </Typography>
            <OtpInput
              errorStyle={{
                border: "2px solid #ed4c5c",
                color: "#ed4c5c",
                backgroundColor: "white",
              }}
              hasErrored={error}
              value={otp}
              onChange={handleOtpChange}
              numInputs={6}
              separator={<div style={{ marginLeft: "12px" }}></div>}
              containerStyle={{ marginBottom: "20px" }}
              inputStyle={{
                width: "40px",
                height: "40px",
                backgroundColor: success ? "white" : "#e7e7e7",
                border: success ? "2px solid #99db6e" : 0,
                borderRadius: "10px",
                fontSize: "20px",
                fontFamily: "Raleway",
                color: success ? "#99db6e" : "#333333",
              }}
            />
            <Typography mb={1} variant="subtitle1" color="text.hint">
              {t("Didn’t receive OTP code?")}
            </Typography>
            <Button onClick={onResend}>{t("Resend Code")}</Button>
            <Button
              sx={{
                px: 4,
                mb: 3,
                width: "258px",
              }}
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              name="verify-otp"
              disabled={otp.length != 6 || clicked}
            >
              {t("Verify & Proceed")}
            </Button>
            <Typography color="text.hint">
              {t("Not your mail?")}
              <Link fontWeight="bold" color="inherit" href="#" onClick={handleClose}>
                {""}
                {t("Change now")}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default ConfirmOtp;
